
<h1 class="text-4xl mb-4">Keine Berechtigung</h1>
<div class="mt-0">Wende dich an den IT-Service (ITI), um die entsprechende Berechtigung zu erhalten.</div>